import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TermsConditionsModalComponent } from '../terms-conditions-modal/terms-conditions-modal.component';
import { PrivacyPolicyModalComponent } from '../privacy-policy-modal/privacy-policy-modal.component';

@Component({
  selector: 'app-flight-hotel',
  templateUrl: './flight-hotel.component.html',
  styleUrls: ['./flight-hotel.component.scss']
})
export class FlightHotelComponent {
  @Output() bookNow = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  @Input() variant: 'flight' | 'hotel' | 'travels' = 'flight';

  termsAccepted = true;
  communicationConsent = true;
  canBookNow = false;

  constructor(
    private modalController: ModalController
  ) {this.updateButtonState();}
  

  updateButtonState() {
    this.canBookNow = this.termsAccepted && this.communicationConsent;
  }

  onBookNow() {
    if (this.canBookNow) {
      this.bookNow.emit();
      this.dismiss('book');
    }
  }

  onClose() {
    this.closeModal.emit();
    this.dismiss('close');
  }

  dismiss(action?: string) {
    this.modalController.dismiss({
      action: action
    });
  }

  get imageSrc(): string {
    switch (this.variant) {
      case 'hotel':
        return 'https://img.travelx.ai/bfl/bajaj_hotel.png';
      case 'travels':
        return '/assets/images/bajaj_travels.webp';
      default:
        return 'https://img.travelx.ai/bfl/bajaj_flight.png';
    }
  }

  async openTermsConditionsModal() {
    const modal = await this.modalController.create({
      component: TermsConditionsModalComponent,
      cssClass: 'terms-conditions-modal',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps: {}
    });
    return await modal.present();
  }

  async openPrivacyPolicyModal() {
    const modal = await this.modalController.create({
      component: PrivacyPolicyModalComponent,
      cssClass: 'privacy-policy-modal',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps: {}
    });
    return await modal.present();
  }
}
